import { gql } from '@apollo/client';
import React from 'react';
import Button from '../../components/Button';
import ExternalBrandLogo from '../../components/ExternalBrandLogo';
import type { FeatureIntegrationPrompt_IntegrationFragment } from '../../graphql/generated/graphqlTypes';
import type { IntegrationPlatformInfo } from '../../integrations/IntegrationPlatformInfo';
import styles from './FeatureIntegrationPrompt.module.scss';
import installIntegration from './installIntegration';
import { useAppDispatch } from '../../app/redux/useAppSelector';

const INTEGRATION_FRAGMENT = gql`
  fragment FeatureIntegrationPrompt_integration on Integration {
    id
    platform
  }
`;

interface FeatureIntegrationPromptProps {
  description?: string;
  feature?: string;
  integration: FeatureIntegrationPrompt_IntegrationFragment;
  platformInfo: IntegrationPlatformInfo;
}

const FeatureIntegrationPrompt = ({
  description,
  feature,
  integration: { platform },
  platformInfo,
}: FeatureIntegrationPromptProps) => {
  const dispatch = useAppDispatch();
  const { icon, name } = platformInfo;

  const handleConnectClick = () =>
    installIntegration({
      dispatch,
      feature,
      platform,
      redirectUrl: window.location.href,
    });

  return (
    <div className={styles.authPrompt}>
      <div className={styles.authDescription}>{description}</div>
      <div className={styles.buttonContainer}>
        <Button variant="secondary" onClick={handleConnectClick}>
          <span className={styles.logoContainer}>
            <ExternalBrandLogo {...icon} height={14} />
          </span>
          Connect with {name}
        </Button>
      </div>
    </div>
  );
};

FeatureIntegrationPrompt.fragments = {
  integration: INTEGRATION_FRAGMENT,
};

export default FeatureIntegrationPrompt;
